<template>
<div class='bto-sb-element'>
 <div class="bto-sb-event-horse">
    <antepost-race v-for="(items,idx) in HRraces" :key="idx" :items="items" v-on="$listeners" />
 </div>
</div>
</template>

<script>
  import AntepostRace from './anntepost-race';

  export default {
    name: 'AntepostRaces',
    components: {
      AntepostRace,
    },
    data() {
      return {
        tabExpanded: true,
        tabCollapsed: false,
      };
    },
    props: {
      HRraces: {
        type: Array,
        default: () => [],
      },
    },
  };
</script>

